/**
 * The custom non empty array definition that provides shortcuts:
 * - "readonly" - (default because it is a general practice)
 * - "writable"
 */
export type NonEmptyArray<
	TElement = unknown,
	TAccess extends "readonly" | "writable" = "readonly",
> = TAccess extends "writable" ? [TElement, ...Array<TElement>] : readonly [TElement, ...ReadonlyArray<TElement>];

export function isNonEmptyArray<T>(array: Array<T>): array is NonEmptyArray<T, "writable">;
export function isNonEmptyArray<T>(array: ReadonlyArray<T>): array is NonEmptyArray<T>;

export function isNonEmptyArray(array: ReadonlyArray<unknown>): array is NonEmptyArray {
	return array.length > 0;
}
